import { parse, isValid } from 'date-fns';
import { UK_DATE_VALIDATOR, UK_SSN_VALIDATOR } from '@uikit/components/uk-form-controls';

function validateParamDate(date, paramName) {
    if (!(date instanceof Date)) {
        if (!isValid(date)) {
            console.warn(paramName + " is not valid date will not work properly.");
        }
        else {
            date = parse(date);
        }
    }
    return date;
}
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
var UKValidators = /** @class */ (function () {
    function UKValidators() {
    }
    // To execute validation only if date is valid
    UKValidators.baseDateValidator = function (control, validate) {
        if (isEmptyInputValue(control.value)) {
            return null;
        }
        var value = control.value;
        var date = parse(value);
        if (value.length === 10 && isValid(date)) {
            return validate(date);
        }
        return null;
    };
    /**
     * Check that control date is greater than minDate
     * @param minDate date to compare
     * @returns ValidatorFn
     */
    UKValidators.minDate = function (minDate) {
        var _this = this;
        minDate = validateParamDate(minDate, 'minDate');
        return function (control) {
            return _this.baseDateValidator(control, function (date) {
                var isValidDate = date >= minDate;
                return isValidDate ? null : { ukMinDateError: true };
            });
        };
    };
    /**
     * Check that control date is lower than maxDate
     * @param maxDate date to compare
     * @returns ValidatorFn
     */
    UKValidators.maxDate = function (maxDate) {
        var _this = this;
        maxDate = validateParamDate(maxDate, 'maxDate');
        return function (control) {
            return _this.baseDateValidator(control, function (date) {
                var isValidDate = date <= maxDate;
                return isValidDate ? null : { ukMaxDateError: true };
            });
        };
    };
    /**
     * Check that control date is between minDate and maxDate
     * @param minDate date to compare
     * @param maxDate date to compare
     * @returns ValidatorFn
     */
    UKValidators.betweenDate = function (minDate, maxDate) {
        var _this = this;
        minDate = validateParamDate(minDate, 'minDate');
        maxDate = validateParamDate(maxDate, 'maxDate');
        return function (control) {
            return _this.baseDateValidator(control, function (date) {
                var isValidDate = minDate < date && date < maxDate;
                return isValidDate ? null : { ukBetweenDateError: true };
            });
        };
    };
    /**
     * Check valid format for date
     * @param control AbstractControl
     * @returns ValidationErrors | null
     */
    UKValidators.validDate = function (control) {
        if (isEmptyInputValue(control.value)) {
            return null;
        }
        var isValidDate = UK_DATE_VALIDATOR.test(control.value);
        return isValidDate ? null : { ukMaskDateError: true };
    };
    /**
     * Check valid format for a SSN
     * @param control AbstractControl
     * @returns ValidationErrors | null
     */
    UKValidators.validSSN = function (control) {
        if (isEmptyInputValue(control.value)) {
            return null;
        }
        var isValidSSN = UK_SSN_VALIDATOR.test(control.value);
        return isValidSSN ? null : { ukMaskSSNError: true };
    };
    /**
     * Check if a value is duplicated
     * @param values Array of strings
     * @returns ValidatorFn
     */
    UKValidators.duplicate = function (values) {
        // Hack to allow Angular Compiler support lambda functions
        var validator = function (control) {
            if (isEmptyInputValue(control.value))
                return null;
            var idx = values.indexOf(control.value);
            return idx >= 0 ? { ukDuplicate: true } : null;
        };
        return validator;
    };
    /**
     * Check if control value doesn't contain POBox
     * @param control AbstractControl
     * @returns ValidationErrors | null
     */
    UKValidators.POBoxNotAllow = function (control) {
        if (isEmptyInputValue(control.value)) {
            return null;
        }
        var isInvalid = UKValidators.poBoxRegex.test(control.value);
        return isInvalid ? { ukPOBox: true } : null;
    };
    /**
     * Check valid format for username
     * @param control AbstractControl
     * @returns ValidationErrors | null
     */
    UKValidators.validUserName = function (control) {
        if (isEmptyInputValue(control.value)) {
            return null;
        }
        var length = control.value ? control.value.length : 0;
        var isInvalid = true;
        if (length >= 6 && length <= 30) {
            isInvalid = !UKValidators.userNameRegex.test(control.value);
        }
        return isInvalid ? { ukUserName: true } : null;
    };
    /**
     * Check valid format for password
     * @param control AbstractControl
     * @returns ValidationErrors | null
     */
    UKValidators.validPassword = function (control) {
        if (isEmptyInputValue(control.value)) {
            return null;
        }
        var isInvalid = !UKValidators.passwordRegex.test(control.value);
        return isInvalid ? { ukPassword: true } : null;
    };
    /**
     * Check valid format for email
     * @param control AbstractControl
     * @returns ValidationErrors | null
     */
    UKValidators.validEmail = function (control) {
        if (isEmptyInputValue(control.value)) {
            return null;
        }
        var length = control.value ? control.value.length : 0;
        var isInvalid = true;
        if (length >= 6 && length <= 68) {
            isInvalid = !UKValidators.emailRegex.test(control.value);
        }
        return isInvalid ? { ukEmail: true } : null;
    };
    /**
     * Check valid format for street
     * @param control AbstractControl
     * @returns ValidationErrors | null
     */
    UKValidators.validStreet = function (control) {
        if (isEmptyInputValue(control.value)) {
            return null;
        }
        var isInvalid = !UKValidators.streetRegex.test(control.value);
        return isInvalid ? { ukStreet: true } : null;
    };
    //#region Angular Forms Validators
    /**
     * Check that control value don't exceeds length
     * @param maxLength length
     * @returns ValidatorFn
     */
    UKValidators.maxLength = function (maxLength) {
        var validator = function (control) {
            // TODO: Add maxLength Attribute
            var length = control.value ? control.value.length : 0;
            return length > maxLength ?
                { ukMaxlength: { requiredLength: maxLength, actualLength: length } } :
                null;
        };
        return validator;
    };
    /**
     * Check that control value has minimum length
     * @param minLength length
     * @returns ValidatorFn
     */
    UKValidators.minLength = function (minLength) {
        var validator = function (control) {
            // TODO: Add minLength Attribute
            if (isEmptyInputValue(control.value)) {
                return null;
            }
            var length = control.value ? control.value.length : 0;
            return length < minLength ?
                { ukMinlength: { requiredLength: minLength, actualLength: length } } :
                null;
        };
        return validator;
    };
    // private static userNameRegex = /^[A-Za-z0-9_\-+.@]{6,30}$/;
    UKValidators.userNameRegex = new RegExp('^[A-Za-z0-9_\\-+.@]{6,30}$');
    UKValidators.poBoxRegex = new RegExp('\\b(P|p)(ost|ostal)?([ \\.]*(O|o|0)(ffice|FFICE)?)?([ \\.]*(box|BOX|Box|code|CODE))?\\b');
    UKValidators.streetRegex = new RegExp('^((\\b.*[a-zA-Z0-9]+.*\\b)\s*){2,}$');
    UKValidators.emailRegex = new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');
    UKValidators.passwordRegex = new RegExp('^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[#?!@$%^&*+-])[A-Za-z0-9#?!@$%^&*+-]{8,50}$');
    return UKValidators;
}());

export { UKValidators };
//# sourceMappingURL=uikit-components-uk-validators.js.map
